module.exports = __webpack_public_path__ + "img/engineer-logo-2-active.7ba683cc.png";